import React from "react";

// Pagina publica de exclusao de conta. A Google Play exige um link onde o
// usuario do app possa pedir a exclusao da conta e dos dados (declaracao de
// Seguranca dos dados). Fica em floow.chat/excluir-conta.
const WHATSAPP = "5562991183472";
const EMAIL = "suportestufa@gmail.com";

const s = {
  pagina: { minHeight: "100vh", background: "#f8fafc", padding: "40px 16px", fontFamily: "inherit", color: "#0f172a" },
  caixa: { maxWidth: 720, margin: "0 auto", background: "#fff", borderRadius: 16, padding: "32px 28px", boxShadow: "0 1px 3px rgba(15,23,42,.08)" },
  h1: { fontSize: 26, margin: "0 0 8px" },
  h2: { fontSize: 18, margin: "28px 0 8px" },
  p: { lineHeight: 1.6, margin: "0 0 10px" },
  li: { lineHeight: 1.6, marginBottom: 6 },
  link: { color: "#2563EB" },
};

const ExcluirConta = () => (
  <div style={s.pagina}>
    <div style={s.caixa}>
      <h1 style={s.h1}>Excluir conta do Floow Chat</h1>
      <p style={s.p}>
        Esta página explica como pedir a exclusão da sua conta no Floow Chat (site e app) e dos dados ligados a ela.
      </p>

      <h2 style={s.h2}>Como pedir a exclusão</h2>
      <ol>
        <li style={s.li}>
          Envie a solicitação pelo WhatsApp{" "}
          <a style={s.link} href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noopener noreferrer">
            +55 62 99118-3472
          </a>{" "}
          ou pelo e-mail{" "}
          <a style={s.link} href={`mailto:${EMAIL}?subject=Excluir%20conta%20Floow%20Chat`}>
            {EMAIL}
          </a>
          , com o assunto "Excluir conta".
        </li>
        <li style={s.li}>Informe o e-mail usado para entrar no Floow Chat e o nome da empresa.</li>
        <li style={s.li}>
          Para sua segurança, vamos confirmar o pedido com quem é administrador da conta antes de excluir.
        </li>
      </ol>
      <p style={s.p}>
        Atendente que só quer sair da equipe pode pedir ao administrador da empresa: ele remove o usuário em
        Usuários, dentro do painel.
      </p>

      <h2 style={s.h2}>O que é excluído</h2>
      <ul>
        <li style={s.li}>A conta da empresa e os usuários (atendentes) cadastrados nela.</li>
        <li style={s.li}>Contatos, conversas, mensagens e arquivos recebidos ou enviados pelo painel.</li>
        <li style={s.li}>Conexões de WhatsApp, Instagram e Facebook, fluxos, agentes de IA e bases de conhecimento.</li>
      </ul>

      <h2 style={s.h2}>O que pode ser mantido</h2>
      <p style={s.p}>
        Registros de pagamento e notas fiscais podem ser mantidos pelo prazo exigido pela legislação brasileira.
        Cópias de segurança são apagadas automaticamente no ciclo normal de substituição.
      </p>

      <h2 style={s.h2}>Prazo</h2>
      <p style={s.p}>A exclusão é feita em até 30 dias depois da confirmação do pedido.</p>
    </div>
  </div>
);

export default ExcluirConta;
